module.exports = __webpack_public_path__ + "img/kc.5a02c482.png";